import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import { useTranslation } from 'react-i18next'
export default function Welcome ({ eventDetails }) {
  const { t } = useTranslation('race')
  // if eventDetails.welcome.columns === 2 show 2 columns when larger than sm, otherwise show 1 column
  const welcomeData = eventDetails?.welcome

  if (!welcomeData) {
    return null
  }

  const { columns = 1, imageSrc, imageTitle, title, content } = welcomeData

  return (
    <Container maxWidth='lg' sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography
          variant='h5' component='h1' gutterBottom sx={{
          fontWeight: 'bold'
        }}
        >
          {title}
        </Typography>
      </Box>

      {columns === 2
        ? (
          <Grid
            container spacing={4} sx={{
            alignItems: 'center'
          }}
          >
            <Grid size={{ xs: 12, md: 6 }} sx={{ alignSelf: 'baseline' }}>
              <Box sx={{ textAlign: 'center' }}>
                {imageSrc && (
                  <Box
                    component='img'
                    src={imageSrc}
                    alt={imageTitle || t('welcome.imageAlt')}
                    sx={
                      {
                        maxWidth: '100%',
                        height: 'auto',
                        borderRadius: 2,
                        mb: 2
                      }
                    }
                  />
                )}
                {imageTitle && (
                  <Typography
                    variant='subtitle1' sx={{
                    fontStyle: 'italic'
                  }}
                  >
                    {imageTitle}
                  </Typography>
                )}
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant='body1' sx={{ lineHeight: 1.8, whiteSpace: 'pre-line' }}>
                {content}
              </Typography>
            </Grid>
          </Grid>
          )
        : (
          <Box>
            {imageSrc && (
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <Box
                component='img'
                src={imageSrc}
                alt={imageTitle || t('welcome.imageAlt')}
                sx={
                  {
                    maxWidth: '100%',
                    height: 'auto',
                    borderRadius: 2
                  }
                }
              />
              {imageTitle && (
              <Typography
                variant='subtitle1'
                sx={{
                  fontStyle: 'italic',
                  mt: 1
                }}
              >
                {imageTitle}
              </Typography>
              )}
            </Box>
            )}
            <Typography variant='body1' sx={{ lineHeight: 1.8, whiteSpace: 'pre-line' }}>
              {content}
            </Typography>
          </Box>
          )}
    </Container>
  )
}
